var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRanking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1147 16.3333H4.66634C3.38301 16.3333 2.33301 17.3833 2.33301 18.6666V25.6666H10.1147V16.3333Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5519 11.6667H12.4368C11.1535 11.6667 10.1035 12.7167 10.1035 14.0001V25.6667H17.8852V14.0001C17.8852 12.7167 16.8469 11.6667 15.5519 11.6667Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3331 19.8333H17.8848V25.6666H25.6664V22.1666C25.6664 20.8833 24.6164 19.8333 23.3331 19.8333Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6069 2.41504L15.2253 3.6517C15.3069 3.8267 15.5286 3.99003 15.7153 4.01337L16.8353 4.20004C17.5469 4.3167 17.7219 4.84168 17.2086 5.34335L16.3336 6.21835C16.1819 6.37001 16.1003 6.65002 16.1469 6.84836L16.3919 7.92171C16.5903 8.77337 16.1353 9.10005 15.3886 8.65671L14.3386 8.03838C14.1519 7.92171 13.8369 7.92171 13.6503 8.03838L12.6003 8.65671C11.8536 9.10005 11.3986 8.77337 11.5969 7.92171L11.8419 6.84836C11.8886 6.65002 11.8069 6.35835 11.6553 6.21835L10.7919 5.35503C10.2786 4.84169 10.4419 4.32835 11.1653 4.21168L12.2853 4.02504C12.4719 3.99004 12.6936 3.82671 12.7753 3.66338L13.3936 2.42668C13.7319 1.75001 14.2686 1.75004 14.6069 2.41504Z",
    stroke: "white",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.cd0a63fe441adc1ab89794f9df3b0d29.svg";
export { ForwardRef as ReactComponent };